import React from 'react';
import { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  Pagination,
  TableHead,
  TableRow,
  Paper,
  Grid,
  Stack,
  List,
  TablePagination,
  ListItem,
  ListItemText,
  Typography,
  Box,
  useMediaQuery,
  Button,
  Alert,
  Modal
} from '@mui/material';
import styles from './RecentWithdrawalsList.module.css';
import AppConfig from '../../AppConfig';
import MyLodder from '../lodder';
import successIcon from '../../assets/svg/success.svg'

import { useAppData } from '../../redux/appDataProvider'; // srini - 30-01-25

const RecentWithdrawalsList = ({ data, handleCancelClick, getStatus, showlodder, withdrawcancel,
  camount, cuserrefno

}) => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const screenSize = useMediaQuery("(max-width : 570px)")
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [withdrawcancel1, setWithdrawcancel1] = React.useState(true);
  const [page, setPage] = useState(0);
  const [mpage, setMPage] = useState(1);
  const [mdata, setMdata] = useState([])

  const { selectedYear, setSelectedYear } = useAppData(); // srini - 30-01-25
  

  useEffect(() => {
    const newArr = data && data.slice((mpage - 1) * 5, (mpage) * 5)
    setMdata(newArr)
  }, [mpage, data])


  if (!data) {

    return null;
  }
  const columns = [
    { id: 'Punch_timetoview', label: 'Date' },
    { id: 'UserRefNo', label: 'UserRefNo' },
    { id: 'Bank_Acno', label: 'Account Number' },
    { id: 'AMOUNT', label: 'Requested Amount' },
    { id: 'AUTH_DUE_AMT', label: 'Processed Amount' },
    { id: 'Status', label: 'Status' },
  ];
  const handlePageChange = (event, newpage) => {
    setPage(newpage);
  }
  const handleMPageChange = (event, newpage) => {
    setMPage(newpage);
  }
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }

  const handleClose = () => {

    setWithdrawcancel1(false)
  }
  // start, Fin yr txt change - srini - 30-01-25
  const getFinancialYearText = (selectedYearData) => {

    const currentDate = new Date()
    const currentYear = currentDate.getFullYear()
    const currentMonth = currentDate.getMonth()

    const currentFinancialStart = currentMonth >= 3 ? currentYear : currentYear - 1
    
    const selectedYearNum = Number(selectedYearData)
    const selectedFinancialStart = selectedYearNum
    const selectedFinancialEnd = selectedYearNum + 1

    if (selectedFinancialStart === currentFinancialStart) {
      return "Recent Transactions"
    } else {
      return `Transaction History in the fin.year ${selectedFinancialStart} - ${selectedFinancialEnd}`
    }
  }

  const financialYearText = getFinancialYearText(selectedYear.Database_Year)
  // end - srini - 30-01-25
  return (<>
    {
      isSmallScreen ?
        <>
        {/* start, text change - srini - 30-01-25 */}
          <Typography variant="h6" sx={{ margin: "10px 0px 0px 25px" }} className={styles.myCustomText}>
            {financialYearText.replace(/In The Fin\.Year/g, 'in the fin.year')} 
            {/* end - srini - 30-01-25 */}
          </Typography>

          {data.length == 0 ? (
            <Grid style={{ display: 'flex', justifyContent: 'center', marginTop: "20px", width: "100%" }}>
              <Alert severity="warning" style={{ background: 'transparent' }}>No Transactions found !</Alert>
            </Grid>
          ) : (<List sx={{ width: "100%", marginLeft: "20px", marginRight: "15px", marginTop: "15px", background: "#0B1420", borderRadius: "10px" }}>
            {mdata?.map((item, index) => {
              return (
                <ListItem className={styles.listItem} sx={{ display: "flex", flexDirection: "column", alignItems: "start", borderBottom: "2px solid #000000" }}>

                  <ListItemText
                    sx={{ width: "100%" }}
                    primary={
                      <Box display="flex" >
                        <Grid width="35%" padding="0px">
                          <Typography className={styles.listPrimaryText}>Date</Typography>
                        </Grid>
                        <Grid width="35%" padding="0px">
                          <Typography className={styles.listPrimaryText} >Ref No</Typography>
                        </Grid>
                        <Grid width="30%" padding="0px">
                          <Typography className={styles.listPrimaryText}>Status</Typography>
                        </Grid>
                      </Box>
                    }
                    secondary={
                      <Box display="flex">
                        <Grid width="35%" padding="0px">
                          <Typography marginRight="15px" className={styles.listSecondaryText}>{item.Punch_timetoview?.slice(0, 10).split("-").join("/")}
                          </Typography>
                        </Grid>
                        <Grid width="35%" padding="0px" >
                          <Typography className={styles.listSecondaryText}
                            sx={{ wordWrap: "break-word", width: "85%" }}
                          >
                            {item.UserRefNo}
                          </Typography>
                        </Grid>
                        <Grid width="30%" padding="0px" >
                          {getStatus(item.Status) == "Pending" ? <Button
                            variant="outlined"
                            color="inherit"
                            size="small"
                            sx={{ marginBottom: "10px" }}
                            className={styles.cancelButton}
                            // Changed to onTouch event - 23-07-24 - Dev Srini
                            onTouchStart={() => {
                              handleCancelClick(item.UserRefNo, item.Punch_timetoview, item.AMOUNT)
                              setWithdrawcancel1(true)
                            }
                            }
                            fullWidth
                          >
                            Cancel
                          </Button> :
                            <Typography
                              className={getStatus(item.Status) == 'Processed' && styles.statusProcessed || getStatus(item.Status) == 'Cancelled' && styles.statusCancelled}
                              sx={{
                                color: '#FFFFFF',
                                fontSize: '14px',
                                fontWeight: '400',
                                marginBottom: "10px"
                              }}
                            >{getStatus(item.Status).toUpperCase()}</Typography>}
                        </Grid>
                      </Box>
                    }
                  />
                  <ListItemText
                    sx={{ width: "100%" }}
                    primary={
                      <Box display="flex" >
                        <Grid width="35%" padding="0px">
                          <Typography className={styles.listPrimaryText}>Account No.</Typography>
                        </Grid>
                        <Grid width="35%" padding="0px" >
                          <Typography className={styles.listPrimaryText} >Requested</Typography>
                        </Grid>
                        <Grid width="30%" padding="0px" >
                          <Typography className={styles.listPrimaryText}>Processed</Typography>
                        </Grid>
                      </Box>
                    }
                    secondary={
                      <Box display="flex">
                        <Grid width="35%" padding="0px">
                          <Typography marginRight="15px" className={styles.listSecondaryText}>
                            <span className={styles.x}>{"x".repeat(item.Bank_Acno.length - 4)}</span>{item.Bank_Acno.slice(-4)}
                          </Typography>
                        </Grid>
                        <Grid width="35%" padding="0px" >
                          <Typography className={styles.listSecondaryText}  >
                            {item.AMOUNT}
                          </Typography>
                        </Grid>
                        <Grid width="30%" padding="0px" >
                          <Typography className={styles.listSecondaryText} >
                            {item.AMOUNT}
                          </Typography>
                        </Grid>
                      </Box>
                    }
                  />
                </ListItem>
              )
            })}
            <Grid sx={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
              <Pagination showFirstButton showLastButton count={Math.ceil(data.length / 5)} size="small" page={mpage}
                onChange={handleMPageChange} />
            </Grid>
          </List>)}
        </> :

        <TableContainer component={Paper} className={styles.tablecontainer} >
          {/* start, text change - srini - 30-01-25 */}
          <Typography variant="h5" sx={{ marginTop: "10px" }} gutterBottom className={styles.myCustomText}>
            {financialYearText.replace(/In The Fin\.Year/g, 'in the fin.year')}
            {/* end - srini - 30-01-25 */}
          </Typography>
          {data.length == 0 ? (
            <Table>
              <TableRow style={{ display: 'flex', justifyContent: 'center', marginTop: "20px" }}>
                <Alert severity="warning" style={{ background: 'transparent' }}>No Transactions found !</Alert>
              </TableRow>
            </Table>
          ) : (<Table sx={{ background: "#0B1420", marginTop: "20px", borderRadius: "10px" }}>
            <TableHead >
              <TableRow>
                {columns.map((column) => (
                  <TableCell className={styles.tablecellheader} key={column.id}>{column.label}</TableCell>
                ))}
                {/* <TableCell className={styles.tablecellheader} style={{ display: 'none' }}>Actions</TableCell> */}
              </TableRow>
            </TableHead>


            <TableBody>



              {data.length !== 0 &&
                data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                  <TableRow key={index}>
                    {columns.map((column) => (
                      <TableCell
                        className={`${styles.tablecell} ${column.id === 'Status' && styles.tablecelllow}`}
                        key={column.id}
                      >
                        {column.id === 'Status' ?
                          <Typography className={getStatus(row.Status) == 'Pending' && styles.statusPending || getStatus(row.Status) == 'Processed' && styles.statusProcessed || getStatus(row.Status) == 'Cancelled' && styles.statusCancelled} >
                            {getStatus(row.Status).toUpperCase() == "PENDING" ? "PROCESSING" : getStatus(row.Status).toUpperCase()}
                          </Typography> :
                          <Typography sx={{ fontSize: "12px" }}>
                            {column.id == "Punch_timetoview" ? row[column.id].slice(0, 10).split("-").join("/") : row[column.id]}
                          </Typography>}

                      </TableCell>
                    ))}
                    <TableCell className={styles.tablecell} sx={{ borderTop: "2px solid black" }}>
                      {AppConfig.withdrawStatus[row.Status] === "Pending" && (
                        <Button
                          variant="outlined"
                          color="inherit"
                          className={styles.cancelButton}
                          onClick={() => {
                            handleCancelClick(row["UserRefNo"], row["Punch_timetoview"], row['AMOUNT'])

                            setWithdrawcancel1(true)
                          }
                          }
                        >
                          Cancel
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))}

            </TableBody>
          </Table>)}
          {data.length > 0 && <TablePagination
            sx={{ background: "#0B1420" }}
            rowsPerPageOptions={[1, 10, 20, 50]}
            rowsPerPage={rowsPerPage}
            page={page}
            count={data.length}
            component="div"
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
          />}
        </TableContainer>

    }
    <Modal
      open={withdrawcancel && withdrawcancel1}
      disableBackdropClick={false}
      onClose={() => handleClose()}
      sx={{ border: 'none' }}>
      <Box

        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: isSmallScreen ? '95%' : '50%',
          height: 'auto',

          outline: 'none',
          background: '#ffffff',
          p: 4,
          borderRadius: '8px',
          padding: '2%',
          justifyContent: 'center', alignItems: 'center',
          "@media only screen and (max-device-width: 480px)": {
            width: '90%',


          }
        }}
      >
        <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
          <img src={successIcon} alt={successIcon} width='80'></img>
        </Grid>
        <Grid sx={{ width: '100%', display: 'flex', justifyContent: 'center', flexDirection: "column", gap: "10px", marginTop: "10px", padding: "0px 20px" }}>
          <Typography className={styles.payment_succ}>Withdraw Cancel Successful</Typography>
          <Typography className={styles.payment_msg}>Ref No: {cuserrefno}</Typography>

          <Grid style={{ width: '100%', borderBottom: '1px solid #D9D9D9' }}></Grid>
          <Typography className={styles.payment_msg}>Amount: ₹ {camount}</Typography>

        </Grid>
      </Box>
    </Modal>
    <MyLodder canShow={showlodder} />
  </>
  );
};

export default RecentWithdrawalsList;
